import styled from "styled-components";

import { GroupInfoLoadingSkeletonContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageImersiveLayout/components/atoms/GroupInfo/LoadingSkeleton/styles";

export const ClassworkPageImersiveLayoutLoadingSkeletonContainer = styled.div`
  margin-top: 13rem;
  color: white;

  background-color: ${({ theme }) => theme.classwork.imersive.backgroundColor};

  padding-bottom: 7rem;

  height: 100%;

  @media (max-width: 500px) {
    margin-top: 9rem;
  }

  > .content {
    width: 100%;
    margin: 0 auto;

    grid-area: content;
    z-index: 1;

    max-width: 1460px;

    padding: 1.5rem 1rem 0 1rem;

    ${GroupInfoLoadingSkeletonContainer} {
      margin-top: 0rem;
    }

    @media (max-width: 1600px) {
      max-width: 1100px;

      padding: 0.5rem 1rem 0 1rem;
    }
  }
`;
